var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5535 1.84451C12.5178 1.35993 11.4104 1.00775 10.2526 0.80722C10.1104 1.06429 9.94429 1.41006 9.82976 1.68512C8.599 1.50003 7.37956 1.50003 6.17144 1.68512C6.05693 1.41006 5.88704 1.06429 5.74357 0.80722C4.58454 1.00775 3.47584 1.36122 2.44013 1.84707C0.351095 5.00388 -0.215207 8.08227 0.0679444 11.117C1.4535 12.1517 2.79627 12.7802 4.11638 13.1915C4.44233 12.7429 4.73302 12.2661 4.98345 11.7635C4.5065 11.5823 4.04969 11.3586 3.61805 11.099C3.73256 11.0141 3.84457 10.9254 3.95279 10.8342C6.58546 12.0655 9.44593 12.0655 12.0472 10.8342C12.1566 10.9254 12.2686 11.0141 12.3819 11.099C11.949 11.3599 11.4909 11.5835 11.014 11.7648C11.2644 12.2661 11.5538 12.7442 11.881 13.1928C13.2024 12.7815 14.5464 12.1529 15.932 11.117C16.2642 7.59898 15.3644 4.54886 13.5535 1.84451ZM5.34212 9.25065C4.55181 9.25065 3.9037 8.51286 3.9037 7.6144C3.9037 6.71595 4.53797 5.97688 5.34212 5.97688C6.14628 5.97688 6.79437 6.71465 6.78053 7.6144C6.78178 8.51286 6.14628 9.25065 5.34212 9.25065ZM10.6578 9.25065C9.86752 9.25065 9.21941 8.51286 9.21941 7.6144C9.21941 6.71595 9.85366 5.97688 10.6578 5.97688C11.462 5.97688 12.1101 6.71465 12.0962 7.6144C12.0962 8.51286 11.462 9.25065 10.6578 9.25065Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.d79051b688916fb32f6e0d4c7203eec8.svg";
export { ForwardRef as ReactComponent };